import { useLocale } from 'next-intl';

export function getLocalizedName(
  obj: any,
  locale: string,
  defaultAttr = 'name' as string
) {
  return obj[defaultAttr + '-' + locale] || obj[defaultAttr] || '';
}

export function useGetLocalizedName() {
  const locale = useLocale();
  return (obj: any, defaultAttr = 'name' as string) => {
    if (!obj) {
      return '';
    }
    return getLocalizedName(obj, locale, defaultAttr);
  };
}
